






























import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import LineChart from "../../Charts/LineChart.vue";

@Component({
    components: {
        LineChart
    }
})
export default class CommunityDashboard extends Vue {
    public communityOptions = {
        responsive: true,
        maintainAspectRatio: false,
        aspectRatio: 2,
        title: {
            display: true,
            text: "Users actions on community"
        },
        scales: {
            yAxes: [
                {
                    ticks: {
                        min: 0,
                        suggestedMax: 50,
                        maxTicksLimit: 6
                    }
                }
            ]
        }
    };
    public meetupOptions = {
        responsive: true,
        maintainAspectRatio: false,
        aspectRatio: 2,
        title: {
            display: true,
            text: "Participations on meetups"
        },
        scales: {
            xAxes: [
                {
                    type: "time",
                    display: true,
                    ticks: {
                        major: {
                            fontStyle: "bold",
                            fontColor: "#FF0000"
                        }
                    }
                }
            ],
            yAxes: [
                {
                    ticks: {
                        min: 0,
                        suggestedMax: 10
                    }
                }
            ]
        }
    };

    public chartStyle = {
        height: "260px",
        position: "relative"
    };

    public get community() {
        return this.$store.getters.community;
    }
    public set community(val) {
        this.$store.commit("setCommunity", val);
    }
    public get communityData() {
        return this.$store.getters.communityStatsData;
    }
    public get meetupsData() {
        return this.$store.getters.meetupsStatsData;
    }
    public set communityData(data) {
        this.$store.commit("setCommunityStatsData", data);
    }
    public set meetupsData(data) {
        this.$store.commit("setMeetupsStatsData", data);
    }

    async mounted() {
        this.fetchCommunityData(true);
        this.fetchMeetupsData(true);
    }

    public year: number = 2021;

    @Watch("year")
    onYearChange() {
        this.fetchMeetupsData(true);
        this.fetchCommunityData(true);
    }

    async fetchCommunityData(reload) {
        if (!this.communityData || reload) {
            const communityStats: any = await this.$communityApi.getCommunityStats(
                this.community.id,
                this.year
            );
            this.communityData = {
                labels: communityStats.map(cs => cs.month),
                datasets: [
                    {
                        label: "LEAVE",
                        fill: false,
                        backgroundColor: "#4a90e2",
                        borderColor: "#4a90e2",
                        data: communityStats.map(cs => cs.countLeave),
                        lineTension: 0
                    },
                    {
                        label: "JOIN",
                        fill: false,
                        backgroundColor: "#ff5c00",
                        borderColor: "#ff5c00",
                        data: communityStats.map(cs => cs.countJoin),
                        lineTension: 0
                    }
                ]
            };
        }
    }

    async fetchMeetupsData(reload) {
        if (!this.meetupsData || reload) {
            const meetupsStats: any = await this.$meetupApi.getMeetupsStats(
                this.community.id,
                this.year
            );
            this.meetupsData = {
                datasets: [
                    {
                        label: "REGISTERED",
                        fill: false,
                        backgroundColor: "#4a90e2",
                        borderColor: "#4a90e2",
                        data: meetupsStats.map(m => {
                            return { x: m.date, y: m.registered };
                        }),
                        lineTension: 0
                    },
                    {
                        label: "CHECKED-IN",
                        fill: false,
                        backgroundColor: "#ff5c00",
                        borderColor: "#ff5c00",
                        data: meetupsStats.map(m => {
                            return { x: m.date, y: m.attended };
                        }),
                        lineTension: 0
                    }
                ]
            };
        }
    }
}
